import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class IsDetectorGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    // TODO: Get the user from memory instead
    // FIXME: Getting the user from memory is returning null
    return this.authService.getStoredUser().pipe(
      map(user => {
        const isDetector = user.profileName.toLowerCase() === 'detection';
        const detectionUrl = '/deteccion';
        if (isDetector && state.url !== detectionUrl) {
          this.router.navigateByUrl(detectionUrl);
          return false;
        }
        return true;
      })
    );
  }
}
